import React, { useEffect, useState } from "react";
import { styled } from "@linaria/react";
import { InputGroup } from "@components/_Revamp/InputGroup";
import { isEmpty } from "lodash";
import ModalNameSelector from "@pages/ShieldStarter/Components/Modals/ModalNameSelector";
import useForm from "@utils/useForm";
import { validate } from "./service";
import { PersonalInfo as PersonlaInfoModel } from "@models/ShieldStarter/PersonalInfo.model";
import { formatDate, getSalutationList, nameChunks, NameSelectorItemProps } from "@utils/helpers";

const FormContainer = styled.div`
  display: flex;
  flex-flow: wrap;
  column-gap: 24px;
  row-gap: 24px;

  > div {
    width: 48%;
  }
  @media screen and (max-width: 719px) {
    div {
      width: 100%;
    }
  }
  @media screen and (max-width: 588px) {
    font-size: 14px;
    div {
      width: 100%;
    }
  }
`;

function MyInfoForm(props: any) {
  const { personalInfo, updateInfoFn, errorFn, infoType } = props;
  const { values, errors, patchValue, handleChange, formValid } = useForm(
    new PersonlaInfoModel(personalInfo),
    () => {},
    validate
  );
  const [swapName, setSwapName] = useState<string>("");
  const [firstNameListingChucks, setFirstNameListingChucks] = useState<
    NameSelectorItemProps[]
  >([]);

  const [lastNameListingChucks, setLastNameListingChucks] = useState<
    NameSelectorItemProps[]
  >([]);

  const nameChunks = (tempName: string, type: string, name: string) => {
    let tempObjFN: NameSelectorItemProps[] = [];
    let temp: string[] = [];
    const placeHolder = Symbol("placeholder")
    if (tempName && name) {
      const arr = tempName.split(" ");
      const nameaArr = name.split(" ");
      arr.forEach((e: any, i: number) => {
        const nameIndex = nameaArr.findIndex(
          (name: any, index: number) => name === e
        );
        if(nameIndex !== -1){
        nameaArr.splice(nameIndex,1,placeHolder.toString());}
        const isFirstName = nameIndex !== -1;
        let tempFNChucks = {
          id: i,
          title: e,
          selected: isFirstName,
          order: nameIndex,
        };
        tempObjFN.push(tempFNChucks);
        temp.push(e);
      });
    }
    if (type === "firstName") {
      setFirstNameListingChucks([...tempObjFN]);
    }

    if (type === "lastName") {
      setLastNameListingChucks([...tempObjFN]);
    }
  };

  const MALE = "male";
  const FEMALE = "female";
  const CHILD = "child"; 

  const nameChunksProcesses = (myselfData: any) => {
    let fullName = values["fullName"] || myselfData["fullName"];
    const tempName = fullName.trim();
    let tempFirstName =
      values["firstName"] ||
      myselfData["firstName"] ||
      (tempName && tempName.split(" ").slice(0, -1).join(" "));
    let tempLastName =
      values["lastName"] ||
      myselfData["lastName"] ||
      (tempName && tempName.split(" ").pop());

    nameChunks(tempName, "firstName", tempFirstName);
    nameChunks(tempName, "lastName", tempLastName);

    let salutationVal = myselfData?.salutation;
    isEmpty(salutationVal) &&
      (salutationVal =
        infoType === CHILD
          ? myselfData?.gender?.toLowerCase() === MALE
            ? "Mr"
            : myselfData?.gender?.toLowerCase() === FEMALE
            ? "Ms"
            : null
          : myselfData?.salutation);

    patchValue({
      ...myselfData,
      firstName: tempFirstName,
      lastName: tempLastName,
      salutation: salutationVal,
    });
    updateInfoFn &&
      updateInfoFn({
        firstName: tempFirstName,
        lastName: tempLastName,
        salutation: salutationVal,
      });
  };

  const firstNameOnChange = (value: any) => {
    let tempName : string = values["fullName"];
    const fullName = tempName.trim();
    let firstNameItems = value;

    let tempObjFirstName: NameSelectorItemProps[] = [];
    let tempObjLastName: NameSelectorItemProps[] = [];
    const arr = fullName.split(" ");

    arr.forEach((e: any, i: number) => {
      const nameIndex = firstNameItems.findIndex(
        (items: any) => i === items.id
      );
      const isFirstName = nameIndex !== -1;
      let tempFNChucks = {
        id: i,
        title: e,
        selected: isFirstName,
        order: nameIndex,
      };
      tempObjFirstName.push(tempFNChucks);
      tempObjLastName.push({ ...tempFNChucks, selected: !isFirstName });
    });

    let fname = "";
    let lname = "";
    firstNameItems.forEach((e: any, i: number) => {
      fname += e.title + " ";
    });
    tempObjLastName.forEach((e) => {
      e.selected && (lname += e.title + " ");
    });

    setFirstNameListingChucks([...tempObjFirstName]);
    setLastNameListingChucks([...tempObjLastName]);

    patchValue({
      firstName: fname.trim(),
      lastName: lname.trim(),
    });
    updateInfoFn &&
      updateInfoFn({
        firstName: fname.trim(),
        lastName: lname.trim(),
      });
  };

  const lastNameOnchange = (value: any) => {
    let tempName = values["fullName"];
    const fullName = tempName.trim();
    let lastNameItems = value;

    let tempObjFirstName: NameSelectorItemProps[] = [];
    let tempObjLastName: NameSelectorItemProps[] = [];
    const arr = fullName.split(" ");

    arr.forEach((e: any, i: number) => {
      const nameIndex = lastNameItems.findIndex((items: any) => i === items.id);
      const isFirstName = nameIndex !== -1;
      let tempFNChucks = {
        id: i,
        title: e,
        selected: isFirstName,
        order: nameIndex,
      };
      tempObjLastName.push(tempFNChucks);
      tempObjFirstName.push({ ...tempFNChucks, selected: !isFirstName });
    });

    let fname = "";
    let lname = "";
    lastNameItems.forEach((e: any) => {
      lname += e.title + " ";
    });
    tempObjFirstName.forEach((e) => {
      e.selected && (fname += e.title + " ");
    });

    setFirstNameListingChucks([...tempObjFirstName]);
    setLastNameListingChucks([...tempObjLastName]);

    patchValue({
      firstName: fname.trim(),
      lastName: lname.trim(),
    });
    updateInfoFn &&
      updateInfoFn({
        firstName: fname.trim(),
        lastName: lname.trim(),
      });
  };

  const onInputChange = (e: any) => {
    handleChange(e);
    updateInfoFn && updateInfoFn({ [e.target.name]: e.target.value });
  };

  useEffect(() => {
    nameChunksProcesses({ ...personalInfo });
  }, []);

  useEffect(() => {
    errorFn && errorFn(errors);
  }, [errors]);

  let salutationList: any = [];
  if (infoType !== CHILD) {
    salutationList =  getSalutationList(values["gender"])
  }

  return (
    <>
      <FormContainer>
        <InputGroup
          labelColor="#434343"
          id="fullName"
          name="fullName"
          label="Full Name"
          placeholder=""
          onChange={(e: any) => {
            let formatted_name = e.target.value.replace(/[^a-z\s]/gi, "");
            onInputChange({
              target: { value: formatted_name, name: e.target.name },
            });
          }}
          invalid={!isEmpty(errors?.fullname?.message)}
          errorMessage={errors?.fullname?.message}
          inputProps={{
            textAlign: "left",
            value: values["fullName"],
          }}
          inputType={"input"}
          readOnly={true}
        />

        {infoType === CHILD ? (
          <InputGroup
            labelColor="#434343"
            id="salutation"
            name="salutation"
            label="Salutation"
            placeholder=""
            onChange={(e: any) => {}}
            invalid={!isEmpty(errors?.fullname?.message)}
            errorMessage={errors?.fullname?.message}
            inputProps={{
              textAlign: "left",
              value: values["salutation"],
            }}
            inputType={"input"}
            readOnly={true}
          />
        ) : (
          <InputGroup
            labelColor="#434343"
            id="salutation"
            name="salutation"
            label="Salutation"
            inputType="dropdown"
            onChange={onInputChange}
            invalid={!isEmpty(errors?.salutation?.message)}
            errorMessage={errors?.salutation?.message}
            placeholder="Select"
            dropdownProps={{
              value: values["salutation"] || "",
              source: salutationList,
            }}
            onBlurShowError={true}
          />
        )}
        <InputGroup
          labelColor="#434343"
          id="firstName"
          name="firstName"
          label="First Name/Given Name"
          placeholder=""
          onChange={(e: any) => {
            let formatted_name = e.target.value.replace(/[^a-z\s]/gi, "");
            onInputChange({
              target: { value: formatted_name, name: e.target.name },
            });
          }}
          invalid={!isEmpty(errors?.firstName?.message)}
          errorMessage={errors?.firstName?.message}
          inputProps={{
            textAlign: "left",
            value: values["firstName"] || "-",
          }}
          inputType={"input"}
          readOnly={true}
          swap={values["firstName"] ? "firstName" : undefined}
          swapModalOpen={(e) => {
            setSwapName(e);
            // nameChunksProcesses(values);
          }}
        />
        <InputGroup
          labelColor="#434343"
          id="lastName"
          name="lastName"
          label="Last Name/Family Name"
          placeholder=""
          onChange={(e: any) => {
            let formatted_name = e.target.value.replace(/[^a-z\s]/gi, "");
            onInputChange({
              target: { value: formatted_name, name: e.target.name },
            });
          }}
          invalid={!isEmpty(errors?.lastName?.message)}
          errorMessage={errors?.lastName?.message}
          inputProps={{
            textAlign: "left",
            value: values["lastName"] || "-",
          }}
          inputType={"input"}
          readOnly={true}
          swap={values["firstName"] ? "lastName" : undefined}
          swapModalOpen={(e) => {
            setSwapName(e);
            // nameChunksProcesses(values);
          }}
        />
        {infoType !== CHILD && (
          <InputGroup
            labelColor="#434343"
            id="mobileNum"
            name="mobileNum"
            label="Mobile Number"
            placeholder=""
            onChange={(e: any) => {
              const regex = /^\d+$/;
              const value = e.target.value;
              if (regex.test(value) && value.length < 9) onInputChange(e);
              if (!value) onInputChange(e);
            }}
            invalid={!isEmpty(errors?.mobileNum?.message)}
            errorMessage={errors?.mobileNum?.message}
            inputProps={{
              textAlign: "left",
              value: values["mobileNum"] || "",
            }}
            inputType={"input"}
            mobCode="+65"
            onBlurShowError={true}
          />
        )}
        {infoType !== CHILD && (
          <InputGroup
            labelColor="#434343"
            id="emailId"
            name="emailId"
            label="Email"
            placeholder=""
            onChange={(e: any) => {
              const regex = /^\s*.{0,50}\s*$/;
              const value = e.target.value;
              if (regex.test(value)) onInputChange(e);
            }}
            invalid={!isEmpty(errors?.emailId?.message)}
            errorMessage={errors?.emailId?.message}
            inputProps={{
              textAlign: "left",
              value: values["emailId"] || "",
            }}
            inputType={"input"}
            onBlurShowError={true}
          />
        )}
        <InputGroup
          labelColor="#434343"
          id="dateOfBirth"
          name="dateOfBirth"
          label="Date of Birth"
          placeholder=""
          onChange={onInputChange}
          invalid={!isEmpty(errors?.dateOfBirth?.message)}
          errorMessage={errors?.dateOfBirth?.message}
          inputProps={{
            textAlign: "left",
            value: formatDate(values["dateOfBirth"]) || "",
          }}
          onBlurShowError={true}
          inputType={"input"}
          readOnly={true}
        />
        <InputGroup
          labelColor="#434343"
          id="nric"
          name="nric"
          label="NRIC"
          placeholder=""
          onChange={onInputChange}
          invalid={!isEmpty(errors?.nric?.message)}
          errorMessage={errors?.nric?.message}
          inputProps={{
            textAlign: "left",
            value: values["nric"] || "",
          }}
          onBlurShowError={true}
          inputType={"input"}
          readOnly={true}
        />
        {infoType !== CHILD && (
          <InputGroup
            labelColor="#434343"
            id="nationality"
            name="nationality"
            label="Nationality"
            placeholder=""
            onChange={onInputChange}
            invalid={!isEmpty(errors?.nationality?.message)}
            errorMessage={errors?.nationality?.message}
            inputProps={{
              textAlign: "left",
              value: values["nationality"] || "",
            }}
            onBlurShowError={true}
            inputType={"input"}
            readOnly={true}
          />
        )}
        {infoType !== CHILD && (
          <InputGroup
            labelColor="#434343"
            id="residentialStatus"
            name="residentialStatus"
            label="Residential Status"
            placeholder=""
            onChange={onInputChange}
            invalid={!isEmpty(errors?.residentialStatus?.message)}
            errorMessage={errors?.residentialStatus?.message}
            inputProps={{
              textAlign: "left",
              value: values["residentialStatus"] || "",
            }}
            onBlurShowError={true}
            inputType={"input"}
            readOnly={true}
          />
        )}
        <InputGroup
          labelColor="#434343"
          id="gender"
          name="gender"
          label="Gender"
          placeholder=""
          onChange={onInputChange}
          invalid={!isEmpty(errors?.gender?.message)}
          errorMessage={errors?.gender?.message}
          inputProps={{
            textAlign: "left",
            value: values["gender"] || "",
          }}
          onBlurShowError={true}
          inputType={"input"}
          readOnly={true}
        />
      </FormContainer>
      <ModalNameSelector
        show={swapName !== "" ? true : false}
        headerTitle={
          swapName === "firstName"
            ? "first name/given name"
            : "last name/family name"
        }
        selectorItems={
          swapName === "firstName"
            ? firstNameListingChucks
            : lastNameListingChucks
        }
        onCancelClick={() => {
          setSwapName("");
        }}
        onSaveClick={(value) => {
          setSwapName("");
          let target = {
            target: {
              name: swapName,
              value: value.name,
            },
          };
          onInputChange(target);
          swapName === "firstName" && firstNameOnChange(value.nameItems);
          swapName === "lastName" && lastNameOnchange(value.nameItems);
        }}
      />
    </>
  );
}
export default MyInfoForm;
